import React from 'react'
import './HeroBanner.css'
import hero_banner from '../Assets/hero-banner.png'
import {Link} from 'react-router-dom'

const HeroBanner = () => {
  return (
    <div className='hero-banner'>
        <img className='banner-img' src={hero_banner} alt="" />
         <Link to="/cart" ><button className='shop-now' >Shop now</button></Link>
    </div>
  )
}

export default HeroBanner